import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface OnboardingStepItem {
  id: number
  name: string
  description: string
}

interface OnboardingStepProgressProps {
  steps: OnboardingStepItem[]
  currentStep: number
}

export function OnboardingStepProgress({ steps, currentStep }: OnboardingStepProgressProps) {
  return (
    <nav aria-label="Onboarding progress" className="rounded-2xl border border-white/70 bg-white/80 p-4 shadow-sm backdrop-blur-sm sm:p-6">
      <ol className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {steps.map((step) => {
          const isDone = currentStep > step.id
          const isCurrent = currentStep === step.id

          return (
            <li key={step.id} className="h-full">
              <div
                className={cn(
                  'h-full min-h-[60px] rounded-xl border p-2 transition-all',
                  isDone && 'border-spectrum-blue/35 bg-spectrum-blue/5',
                  isCurrent &&
                    'border-spectrum-blue/50 bg-gradient-to-r from-spectrum-teal/10 to-spectrum-blue/10 shadow-sm',
                  !isDone && !isCurrent && 'border-gray-200 bg-white/80'
                )}
              >
                <div className="flex h-full items-center gap-2">
                  <div
                    className={cn(
                      'flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition-colors',
                      isDone && 'border-spectrum-blue bg-spectrum-blue text-white',
                      isCurrent && 'border-spectrum-blue text-spectrum-blue bg-white',
                      !isDone && !isCurrent && 'border-gray-300 bg-white text-gray-500'
                    )}
                  >
                    {isDone ? <Check className="h-4 w-4" /> : step.id}
                  </div>
                  <div className="flex min-w-0 flex-col justify-center leading-tight">
                    <p className="truncate text-xs font-semibold text-gray-900">{step.name}</p>
                    <p className="line-clamp-1 text-xs text-gray-500">{step.description}</p>
                  </div>
                </div>
              </div>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
